import { useQuery } from '@tanstack/react-query';
import { RoleApi } from '../apis/role-api';
import CloseableErrorMessage from '../components/CloseableErrorMessage';

export const RoleQueries = {
  useRolesList: () =>
    useQuery({
      queryKey: ['roleList'],
      queryFn: async () => await RoleApi.getCSRoles(),
      onError: () => CloseableErrorMessage('Error getting CS Roles.'),
    }),
};
